export enum MenuEventType {
  close_session = 'close_session',
  new_incident = 'new_incident',
  change_pass = 'change_pass'
}
